import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/proceeding');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions(
  'proceeding',
  validationApi,
);

export function getProceedingValidationHistoryOptions(proceedingId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(proceedingId);
}

export function getProceedingValidationOptions(proceedingId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(proceedingId);
}

export function useValidateProceeding(proceedingId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(proceedingId, queryClient));
}
